import React from "react"

import "../style/PrivacyPolicy.scss"
import { PageLanding } from "../components"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"

function PrivacyPolicy() {
	return (
		<>
			<Helmet>
				<title>
					Politica de confidentialitate | Agentie de Web Design - Xposed Agency
				</title>
			</Helmet>

			<PageLanding
				src="https://firebasestorage.googleapis.com/v0/b/xposed-837fc.appspot.com/o/predefined%2Fpolicy.jpg?alt=media&token=3d0c1b2f-bfcc-49c7-bb89-79757bf5f47d"
				title="Politica de confidentialitate"
			/>
			<div className="privacypolicy">
				<h3>POLITICA DE CONFIDENTIALITATE</h3>
				<div className="privacypolicy__container">
					<p className="privacypolicy__content">
						Data ultimei actualizări: 10.03.2021
						<br />
						<br />
						Prin prezenta Politică ne propunem să vă informăm despre modul în
						care colectăm, utilizăm, transferăm și protejăm datele dumneavoastră
						cu caracter personal, în conformitate cu prevederile Regulamentului
						(UE) 2016/679 (denumit în continuare GDPR).
					</p>
					<h5>CINE SUNTEM NOI</h5>
					<p className="privacypolicy__content">
						SC XPOSED AGENCY SRL este o companie care vă oferă o gamă variată de
						produse apicole. Sediul nostru este situat în Municipiul București,
						sector 4 str. Drumul Jilavei, nr. 13, Parter, camera 1. Suntem
						înregistrați la Oficiul Registrului Comerțului sub nr. J40/1786/2016
						și avem codul unic de identificare 40629175.
						<br />
						<br />
						Datele noastre de contact sunt:
						<br />
						E-mail:{" "}
						<Link className="privacypolicy__link" to="/contact#contactForm">
							<u>contact@xposed.ro</u>
						</Link>
						<br />
						Tel: 0759 513 983
					</p>
					<h5>PRINCIPII DE PRELUCRARE A DATELOR CU CARACTER PERSONAL</h5>
					<p className="privacypolicy__content">
						XPOSED AGENCY SRL, în calitatea sa de Operator, prelucrează datele
						cu caracter personal ale candidaților care aplică pentru posturile
						disponibile, angajaților, reprezentanților partenerilor contractuali
						și altor persoane fizice care interacționează cu compania și/sau
						sunt antrenate în relații contractuale.
					</p>
					<p className="privacypolicy__content">
						Datele cu caracter personal sunt:
					</p>
					<ul>
						<li>
							Prelucrate în mod legal, echitabil și transparent față de persoana
							vizată;
						</li>
						<li>
							Colectate în scopuri determinate, explicite și legitime și nu sunt
							prelucrate ulterior într-un mod incompatibil cu aceste scopuri;
						</li>
						<li>
							Adecvate, relevante și limitate la ceea ce este necesar în raport
							cu scopurile în care sunt prelucrate;
						</li>
						<li>Exacte și actualizate în termen;</li>
						<li>
							Păstrate într-o formă care permite identificarea persoanelor
							vizate pe o perioadă care nu depășește perioada necesară
							îndeplinirii scopurilor în care sunt prelucrate datele;
						</li>
						<li>
							Prelucrate într-un mod care asigură securitatea adecvată a datelor
							cu caracter personal, inclusiv protecția împotriva prelucrării
							neautorizate sau ilegale și împotriva pierderii, a distrugerii sau
							a deteriorării accidentale, prin luarea de măsuri tehnice sau
							organizatorice corespunzătoare.
						</li>
					</ul>
					<h5>CARE SUNT TIPURILE DE DATE PRELUCRATE SI SCOPUL PRELUCRARII</h5>
					<p className="privacypolicy__content">
						În contextul furnizării serviciilor noastre, în scopul încheierii și
						executării contractelor, prelucrăm în principal următoarele tipuri
						de date: nume, prenume, adresă de domiciliu și/sau de facturare,
						adresă de e-mail, număr de telefon.
						<br />
						<br />
						Clienților noștri le dăm posibilitatea de a solicita o ofertă pe
						pagina noastră de prezentare www.xposed.ro. În acest scop colectăm
						numele, prenumele, numărul de telefon și adresa de e-mail.
						<br />
						<br />
						Nu vă utilizăm datele pentru a vă transmite comunicări de marketing
						decât dacă optați în mod expres pentru o astfel de comunicare. Chiar
						și în asemenea cazuri ne asigurăm că aveți la dispoziţie o opțiune
						simplă de a vă dezabona (retragerea consimțământului dumneavoastră)
						în orice moment.
						<br />
						<br />
						Pentru vizitatorii site-ului este posibil să colectăm date prin
						module cookie sau alte tehnologii similare, precum: adresa IP,
						navigatorul de internet, locația, paginile web accesate pe site-ul
						nostru, timpul petrecut pe site, rețeaua de internet, dispozitivul
						utilizat. Pentru mai multe detalii în acest sens, consultați
						Politica de cookies.
					</p>
					<h5>
						CARE SUNT TEMEIURILE LEGALE PE CARE SE BAZEAZA PRELUCRAREA DATELOR
					</h5>
					<p className="privacypolicy__content">
						Datele dumneavoastră sunt prelucrate în vederea încheierii și
						executării diferitelor contracte și în unele cazuri în vederea
						îndeplinirii obligațiilor legale care ne revin. De asemenea, unele
						activități de prelucrare sunt realizate în baza consimțământului
						oferit în prealabil sau pentru atingerea interesului legitim al
						societății.
					</p>
					<h5>CARE ESTE DURATA PRELUCRARII</h5>
					<p className="privacypolicy__content">
						Datele cu caracter personal sunt stucate în vederea prelucrării lor
						pe durata necesară atingerii scopurilor de prelucrare menționate în
						prezenta politică și ulterior, potrivit cerințelor legale.
					</p>
					<h5>CUI TRANSMITEM DATELE CU CARACTER PERSONAL</h5>
					<p className="privacypolicy__content">
						După caz, în baza unor acorduri de protecție a datelor cu caracter
						personal, putem transmite sau oferi acces la anumite date cu
						caracter personal următoarelor categorii de destinatari:
					</p>
					<ul>
						<li>
							furnizorilor de servicii de curierat (cazul contractelor sau a
							altor documente care pot conține date cu caracter personal);
						</li>
						<li>furnizorilor de servicii de plată/bancare;</li>
						<li>
							furnizorilor de servicii IT (dacă se externalizează acest
							serviciu);
						</li>
					</ul>
					<p className="privacypolicy__content">
						În cazul în care ne revine o obligație legală sau dacă este necesar
						pentru a ne apăra un interes legitim, putem de asemenea divulga
						anumite date cu caracter personal unor autorități publice.
					</p>
					<h5>MASURI DE PROTECTIE SI GARANTII</h5>
					<p className="privacypolicy__content">
						XPOSED AGENCY SRL implementează măsuri tehnice și organizatorice
						adecvate în vederea asigurării unui nivel înalt de securitate și
						protecție a datelor cu caracter personal. Noi utilizăm metode şi
						tehnologii de securitate, împreună cu politici aplicate salariaţilor
						şi proceduri de lucru, inclusiv de control şi audit, pentru a
						proteja datele cu caracter personal colectate conform prevederilor
						legale în vigoare.
					</p>
					<h5>DREPTURILE PERSOANEI VIZATE</h5>
					<p className="privacypolicy__content">
						Orice persoană vizată își poate exercita următoarele drepturi, așa
						cum sunt prevăzute de către GDPR:
					</p>
					<ul>
						<li>Dreptul de acces;</li>
						<li>Dreptul de rectificare;</li>
						<li>Dreptul la ștergere;</li>
						<li>Dreptul la restricționarea prelucrării;</li>
						<li>Dreptul la portabilitate;</li>
						<li>Dreptul la opoziție a prelucrării;</li>
						<li>
							Dreptul de a nu face obiectul unei decizii bazate exclusiv pe
							prelucrarea automată, inclusiv crearea de profiluri.
						</li>
						<li>Dreptul de a se adresa ANSPDCP și instanțelor de judecată;</li>
					</ul>
					<p className="privacypolicy__end">
						Pentru exercitarea acestor drepturi ne puteți contacta prin e-mail
						la adresa{" "}
						<Link className="privacypolicy__link" to="/contact#contactForm">
							<u>contact@xposed.ro</u>
						</Link>
						, prin poștă sau curier la adresa - Municipiul București, sector 4
						str. Ghimpați, nr. 23, Bloc 2, Scara 1, Etaj 6, Apartament 27
					</p>
				</div>
			</div>
		</>
	)
}

export default PrivacyPolicy
